
import Vue, { PropType } from 'vue';
import { mapState } from 'pinia';
import { useStore as useLangStore } from '@/stores/v2/lang';
import { Checkmark16, Close16 } from '@carbon/icons-vue';
import {
  ProductPrintDataGroup,
  ProductPrintDataGroupCharacteristic,
} from '@midocean/webapps-shared-domain';

export default Vue.extend({
  name: 'PrintTechniqueGroup',
  components: {
    Checkmark16,
    Close16,
  },
  props: {
    data: {
      type: Object as PropType<ProductPrintDataGroup>,
    },
  },
  computed: {
    ...mapState(useLangStore, ['languageInUse']),
  },
  methods: {
    getTechniqueName(): string {
      const techniqueName = this.data?.nameTranslations.find(
        ({ language }) => language.code === this.languageInUse
      )?.text;
      return techniqueName || '';
    },
    getCharacteristicName(
      characteristic: ProductPrintDataGroupCharacteristic
    ): string {
      const characteristicName = characteristic?.nameTranslations.find(
        ({ language }) => language.code === this.languageInUse
      )?.text;
      return characteristicName || '';
    },
  },
});
